import React from 'react'

import { Divider, Spacer, Row, Col } from '@cleartrip/bento'

import { ReactComponent as FacebookIcon } from 'assets/icons/facebookRounded.svg'
import { ReactComponent as InstagramIcon } from 'assets/icons/instagram.svg'
import { ReactComponent as TwitterIcon } from 'assets/icons/twitter_1.svg'
import { ReactComponent as LinkdinIcon } from 'assets/icons/linkdin.svg'
import { ReactComponent as CleartripIcon } from 'assets/logos/cleartrip-logo-black.svg'
import langTranslate from 'locale'
import FooterSA from './FooterSA'
import FooterAE from './FooterAE'
import FooterCOM from './FooterCOM'
const Footer = () => {
    const currentYear = new Date().getFullYear()
    function getFooterTupple() {
        const domain = window.location.hostname
        // switch (domain) {
        //     case 'www.cleartrip.com':
        //     case 'qa2.cleartrip.com':
        //     case 'qa2new.cleartrip.com':
        //         return <FooterCOM />
        //     case 'me.cleartrip.ae':
        //     case 'www.cleartrip.ae':
        //     case 'www.cleartrip.ae':
        //     case 'localhost':
        //         return <FooterAE />
        //     case 'me.cleartrip.sa':
        //     case 'www.cleartrip.sa':
        //     case 'www.cleartrip.sa':
        //         return <FooterSA />
        //     default:
        //         return <FooterCOM />
        // }
    }
    function getVatCer() {
        const domain = window.location.hostname
        switch (domain) {
            case 'www.cleartrip.sa':
            case 'qa2.cleartrip.sa':
            case 'me.cleartrip.sa':
            case 'www.cleartrip.sa':
            case 'localhost':
                return (
                    <>
                        <div>
                        <a
                                href="https://ui.cltp.co/docs/KSA-VAT-Regn-Cert_100211035568413.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src="https://ui.cltp.co/images/logos/ksa-vat-logo.png"
                                    style={{ height: 36, width: 30 }}
                                />
                            </a>
                        </div>

                        <Spacer className="pl-4" />
                    </>
                )
            default:
                return <></>
        }
    }
    return (
        <footer className='footer'>
            <Spacer className="pt-10" />
            <Divider className="bc-neutral-100" />
            <div className="bg-neutral-0 o-hidden">
                <Row>
                    <Col>
                        {/* <Spacer className="pt-4" /> */}
                        <div className="flex flex-top mt-10 container">
                            <div className='mr-13'>
                                <CleartripIcon/>
                            </div>
                            <div className="flex">
                                {getVatCer()}
                                <div className="flex flex-column">
                                    <ul className="fs-2 flex ls-reset">
                                        <li>
                                            <a
                                                href="/about"
                                                title="About Us"
                                                className="fs-2 fw-500 c-neutral-900 td-none hover:td-underline"
                                            >
                                                {langTranslate('About Us')}
                                            </a>
                                        </li>
                                        {/* <li className="ml-10">
                                            <a
                                                className="fs-2  fw-500 c-neutral-900 td-none hover:td-underline"
                                                title="Careers"
                                                href="/jobs"
                                            >
                                                {langTranslate('Careers')}
                                            </a>
                                        </li> */}
                                        <li className="ml-10">
                                            <a
                                                className="fs-2  fw-500 c-neutral-900 td-none hover:td-underline"
                                                href="/faq"
                                                title="FAQs"
                                            >
                                                {langTranslate('FAQs')}
                                            </a>
                                        </li>
                                        <li className="ml-10">
                                            <a
                                                className="fs-2  fw-500 c-neutral-900 td-none hover:td-underline"
                                                href="/support"
                                                title="Support"
                                            >
                                                {langTranslate('Support')}
                                            </a>
                                        </li>
                                        <li className="ml-10">
                                            <a
                                                className="fs-2  fw-500 c-neutral-900 td-none hover:td-underline"
                                                title="Collections"
                                                href="/collections"
                                            >
                                                {langTranslate('Collections')}
                                            </a>
                                        </li>
                                        <li className="ml-10">
                                            <a
                                                className="fs-2  fw-500 c-neutral-900 td-none hover:td-underline"
                                                href="https://yougotagift.com/shop/en-ae/brands/cleartrip/"
                                            >
                                                {langTranslate('Gift Cards')}
                                            </a>
                                        </li>
                                        <li className="ml-10">
                                            <a
                                                className="fs-2  fw-500 c-neutral-900 td-none hover:td-underline"
                                                title="Contact"
                                                href="/contact"
                                            >
                                                {langTranslate('Contact Us')}
                                            </a>
                                        </li>
                                    </ul>
                                    <Spacer className="pt-4" />
                                    <div className="flex flex-between flex-middle">
                                        <ul className="flex ls-reset">
                                            <li>
                                                <span className="fs-1 c-neutral-400">
                                                    © {currentYear} Cleartrip MEA FZ LLC
                                                </span>
                                            </li>
                                            <li className="ml-1">
                                                <a
                                                    className="fs-1 c-neutral-400 td-none hover:td-underline"
                                                    href="/privacy"
                                                    title="Privacy"
                                                >
                                                    {langTranslate('·  Privacy · ')}
                                                </a>
                                            </li>

                                            <li className="ml-1">
                                                <a
                                                    className="fs-1 c-neutral-400 td-none hover:td-underline"
                                                    href="/security"
                                                    title="Security"
                                                >
                                                    {langTranslate('Security ·')}
                                                </a>
                                            </li>
                                            <li className="ml-1">
                                                <a
                                                    className="fs-1 c-neutral-400 td-none hover:td-underline"
                                                    href="/terms"
                                                    title="Terms of Use"
                                                >
                                                    {langTranslate('Terms of Use')}
                                                </a>
                                            </li>
                                            {/* {getCovidRefundLink()} */}
                                        </ul>
                                        <div className="flex flex-middle">
                                            <span className="fs-2 c-neutral-200 mx-1">{langTranslate('Connect')}</span>
                                            <a href="https://www.facebook.com/CleartripArabia" className="h-4">
                                                <FacebookIcon
                                                    height="16px"
                                                    width="16px"
                                                    className="mx-1 c-neutral-200"
                                                />
                                            </a>
                                            <a href="https://www.instagram.com/cleartrip_arabia" className="h-4">
                                                <InstagramIcon
                                                    height="16px"
                                                    width="16px"
                                                    className="mx-1 c-neutral-200"
                                                />
                                            </a>
                                            <a href="https://twitter.com/cleartrip" className="h-4">
                                                <TwitterIcon height="16px" width="16px" className="mx-1 c-neutral-200" />
                                            </a>
                                            <a href=" https://www.linkedin.com/company/cleartrip-arabia" className="h-4">
                                                <LinkdinIcon height="15px" width="15px" className="mx-1 c-neutral-200" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="flex flex-top">
                                <span className="flex flex-middle nmx-1">
                                    <span className="fs-2 c-neutral-200 mx-1">{langTranslate('Connect')}</span>
                                    <a href="https://facebook.com/cleartrip" className="h-4">
                                        <FacebookIcon height="16px" width="16px" className="mx-1 c-neutral-200" />
                                    </a>
                                    <a href="https://twitter.com/cleartrip" className="h-4">
                                        <TwitterIcon height="16px" width="16px" className="mx-1 c-neutral-200" />
                                    </a>
                                </span>
                            </div> */}
                        </div>
                        <Spacer className="pt-6" />
                        <Divider className="mx-13" />
                        <Spacer className="pt-6" />
                        <div className="container">{getFooterTupple()}</div>
                        <Spacer className="pt-4" />
                    </Col>
                </Row>
            </div>
        </footer>
    )
}

export default Footer
